
import IconBtn from "@/components/molecules/IconBtn.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import {defineComponent, PropType} from "vue";
import TradeContractFormatView, {
  createTradeContractFormatView
} from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import Formatter from "@/utils/Formatter";
import {mapGetters} from "vuex";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import ErrorPopover from "@/components/molecules/ErrorPopover.vue";
import ErrorMessage, {ErrorLevelType} from "@/components/molecules/ErrorMessage";
import {AxiosInstance} from "axios";
import {TradeContractFormat} from "@/store/modules/hcs/tradeContractFormat/model";

export interface TradeContractFormatGroupView extends TradeContractFormatGroup {
  loading: boolean;
  errorMessages: ErrorMessage[];
}

export default defineComponent({
  name: 'FormatGroupTable',
  components: {
    ErrorPopover,
    IconBtn, TextFieldLike, TableInline,
  },
  mixins: [
    TableUtil,
    Formatter,
  ],
  props: {
    groups: {
      type: Array as PropType<TradeContractFormatGroup[]>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    sortable: {
      type: Boolean,
      default: true,
    },
    errorLevel: {
      type: String as PropType<ErrorLevelType>,
      default: 'warn',
    }
  },
  data() {
    return {
      groupsView: [] as TradeContractFormatGroup[],
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
  },
  methods: {
    async loadViews(groupsView: TradeContractFormatGroupView[]) {
      const hcsClient: AxiosInstance = this.hcsClient;
      const h = this.$createElement;
      for (const group of groupsView) {
        const {data: formats} = await hcsClient.get<TradeContractFormat[]>(`/trade_contract_format_groups/${group.id}/formats`);
        const errorFormatNames = formats
          .map(f => createTradeContractFormatView(f, this.$store))
          .filter(f => f.errors().length > 0)
          .map(f => h('li', f.name));

        if(errorFormatNames.length === 0) {
          group.errorMessages = [];
        } else {
          group.errorMessages = [{
            level: this.errorLevel,
            message: h('span', [
              h('p', {
                style: 'margin-bottom: .3rem;'
              }, `以下の取引契約フォーマットに問題があります。`),
              h('ul', errorFormatNames)
            ]),
          }];
        }
        group.loading = false;
      }
    }
  },
  watch: {
    groups: {
      immediate: true,
      handler(groups: TradeContractFormatGroup[]) {
        const groupsView: TradeContractFormatGroupView[] = groups.map(s => ({
          ...s,
          loading: true,
          errorMessages: [],
          formats: [],
        }));
        this.loadViews(groupsView);
        this.groupsView = groupsView;
      }
    }
  }
});
